import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  imports: [RouterOutlet],
})
export class ProductComponent {}
